/* global $:false */
(function () {
    'use strict';

    var overlayApp = angular.module('app.overlay', []);

    //Empty factory to hook into $httpProvider.interceptors
    //Directive will hookup request, response, and responseError interceptors
    overlayApp.factory('app.layout.httpInterceptor', httpInterceptor);
    function httpInterceptor() { return {}; }

    //Hook httpInterceptor factory into the $httpProvider interceptors so that we can monitor XHR calls
    overlayApp.config(['$httpProvider', httpProvider]);
    function httpProvider($httpProvider) {
        $httpProvider.interceptors.push('app.layout.httpInterceptor');
    }

    //Directive that uses the httpInterceptor factory above to monitor XHR calls
    //When a call is made it displays an overlay and a content area
    //No attempt has been made at this point to test on older browsers
    overlayApp.directive('aculocityOverlay',
        ['$q', '$timeout', '$window', 'app.layout.httpInterceptor', 'ATAC', overlay]);

    function overlay($q, $timeout, $window, httpInterceptor, ATAC) {
        var directive = {
            scope: {
                aculocityOverlayDelayIn: '@',
                aculocityOverlayDelayOut: '@',
                aculocityOverlayAnimation: '@'
            },
            restrict: 'EA',
            transclude: true,
            template: getTemplate(),
            link: link
        };
        return directive;

        function getTemplate() {
            return '<div></div>';
        }

        function link(scope) {
            var defaults = {
                overlayDelayIn: 500,
                overlayDelayOut: 500
            };
            var delayIn = scope.aculocityOverlayDelayIn ? scope.aculocityOverlayDelayIn : defaults.overlayDelayIn;
            var delayOut = scope.aculocityOverlayDelayOut ? scope.aculocityOverlayDelayOut : defaults.overlayDelayOut;
            var queue = [];
            var timerPromiseHide = null;

            init();

            function init() {
                wireUpHttpInterceptor();
                if (window.jQuery){
                     wirejQueryInterceptor();
                }
            }

            //Hook into httpInterceptor factory request/response/responseError functions
            function wireUpHttpInterceptor() {

                httpInterceptor.request = function (config) {
                    if (!config.hideOverlay) {
                        processRequest();
                    }
                    return config || $q.when(config);
                };

                httpInterceptor.response = function (response) {
                    processResponse();
                    return response || $q.when(response);
                };

                httpInterceptor.responseError = function (rejection) {
                    processResponse();
                    return $q.reject(rejection);
                };
            }

            //Monitor jQuery Ajax calls in case it's used in an app
            function wirejQueryInterceptor() {
                $(document).ajaxStart(function () { processRequest(); });
                $(document).ajaxComplete(function () { processResponse(); });
                $(document).ajaxError(function () { processResponse(); });
            }

            function processRequest() {
                queue.push({});
                if (queue.length === 1) {
                   $timeout(function () {
                        if (queue.length){
                             ATAC.showLoader();
                        }
                       //Delay showing for 500 millis to avoid flicker
                    }, delayIn);
                }
            }

            function processResponse() {
                queue.pop();
                if (queue.length === 0) {
                    //Since we don't know if another XHR request will be made, pause before
                    //hiding the overlay. If another XHR request comes in then the overlay
                    //will stay visible which prevents a flicker
                    timerPromiseHide = $timeout(function () {
                        //Make sure queue is still 0 since a new XHR request may have come in
                        //while timer was running
                        if (queue.length === 0) {
                            ATAC.hideLoader();
                            if (timerPromiseHide){
                                 $timeout.cancel(timerPromiseHide);
                            }
                        }
                    }, delayOut);
                }
            }
        }
    }
}());
